export const getHumanReadableTimespan = (timespan: number, unit: string): string => {
    const unitMap = {
        MM: 'months',
        ww: 'weeks',
        dd: 'days',
        HH: 'hours',
        mm: 'minutes',
        bzd: 'business days',
        bzh: 'business hours',
    } as const;

    // @ts-expect-error
    const unitDescription = unitMap[unit] || unit;

    const pluralizedUnit = timespan === 1 ? unitDescription.slice(0, -1) : unitDescription;

    return `${timespan} ${pluralizedUnit}`;
};
